module.exports = __webpack_public_path__ + "static/media/framework.4041054c.png";